// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OverlayMenu_wrapper__2e3cP","menuBar":"OverlayMenu_menuBar__141wO","menuItemsWrapper":"OverlayMenu_menuItemsWrapper__3_ocv"};